import React, { MouseEvent } from 'react';
import SvgIcon from 'src/react_components/svg-icon';

export type AnnotationCompletionToggleProps = {
  isDone: boolean;
  disabled?: boolean;
  onToggle: () => void;
};

const AnnotationCompletionToggle = ({ isDone, disabled = false, onToggle }: AnnotationCompletionToggleProps) => {
  const buttonClass = `btn ${isDone ? 'btn-success' : 'btn-outline-success'} d-flex align-items-center ` +
    'align-self-start annotation-completion-toggle';

  // Safety net against the card's click-to-collapse (currently header-only) ever picking up this footer button too.
  const handleClick = (event: MouseEvent<HTMLButtonElement>): void => {
    event.stopPropagation();
    onToggle();
  };

  return (
    <button
      type="button"
      className={buttonClass}
      onClick={handleClick}
      disabled={disabled}
      aria-pressed={isDone}
    >
      <SvgIcon icon="check" />
      Done
    </button>
  );
};

export default AnnotationCompletionToggle;
